"use strict";

export const LanguageEnums = {
    EN: {
        code: 1,
        name: "en-US",
        enLabel:"English",
        cnLabel:"英文"
    },
    CN: {
        code: 2,
        name: "zh-CN",
        enLabel:"Chinese",
        cnLabel:"中文"
    },
    DOUBLE: {
        code: 3,
        name: "Multilingual(English\\Chinese)",
        enLabel:"Multilingual(English\\Chinese)",
        cnLabel:"双语报告（英文\\ 中文）"
    },
    DOUBLE_6: {
        code: 6,
        name: "Chinese & English",
        enLabel:"Chinese & English",
        cnLabel:"中文 & 英文"
    }
}
